var map = {
	"./007-microphone-1.png": 426,
	"./010-home.png": 423,
	"./013-document-1.png": 425,
	"./014-document.png": 421,
	"./015-color-palette.png": 422,
	"./017-video-camera.png": 424,
	"./024-like.svg": 1027,
	"./1.svg": 1028,
	"./155-credit-card.svg": 1029,
	"./2.svg": 1030,
	"./3.svg": 1031,
	"./4.svg": 1032,
	"./New Customer.svg": 1033,
	"./NotOpen.svg": 1034,
	"./Opened.svg": 1035,
	"./Profit.svg": 1036,
	"./SalesRevenue.svg": 1037,
	"./Sent.svg": 1038,
	"./Slack.svg": 1039,
	"./address.svg": 1040,
	"./adobe.svg": 1041,
	"./arrow-left.svg": 528,
	"./arrow-right.svg": 529,
	"./book.svg": 1042,
	"./camera.svg": 1043,
	"./chat.svg": 1044,
	"./clipboard.svg": 1045,
	"./cloud.svg": 1046,
	"./columns.svg": 1047,
	"./documentation.svg": 1048,
	"./file.svg": 1049,
	"./flat.svg": 1050,
	"./headphone.svg": 1051,
	"./iconfinder_trello_2317760.svg": 1052,
	"./idea.svg": 1053,
	"./image.png": 1054,
	"./image.svg": 1055,
	"./label.png": 1056,
	"./layers.svg": 1057,
	"./left.svg": 1058,
	"./logo2.svg": 1059,
	"./logo3.svg": 1060,
	"./logo4.svg": 1061,
	"./logo5.svg": 1062,
	"./logo6.svg": 1063,
	"./logoIn.svg": 1064,
	"./paint.svg": 1065,
	"./protection.svg": 1066,
	"./quote.png": 1067,
	"./repeat.svg": 1068,
	"./right.svg": 1069,
	"./strategy.svg": 1070,
	"./theme.svg": 1071,
	"./user.svg": 1072,
	"./water-fall.svg": 1073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1026;